import { FadeUp } from "../site/motion";

export const SectionHead = ({ eyebrow, title, sub, right, className = "" }) => (
  <FadeUp className={`mb-12 flex flex-col justify-between gap-6 lg:mb-16 lg:flex-row lg:items-end ${className}`}>
    <div className="max-w-3xl">
      {eyebrow && <p className="eyebrow mb-5">{eyebrow}</p>}
      <h2 className="font-display text-4xl font-bold leading-[1.02] tracking-tight text-white sm:text-5xl lg:text-6xl">{title}</h2>
      {sub && <p className="mt-5 text-base text-slate-300 md:text-lg">{sub}</p>}
    </div>
    {right}
  </FadeUp>
);

export const Container = ({ children, className = "", id, testId }) => (
  <section id={id} data-testid={testId} className={`relative mx-auto max-w-[1440px] px-5 py-24 lg:px-12 lg:py-32 ${className}`}>{children}</section>
);
